import React, {Component} from "react";
import _ from "lodash";
import {connect} from "react-redux";
import moment from "moment";
import 'moment-timezone';
import {withTranslation} from "react-i18next";
import LoadingBar from "react-redux-loading-bar";
import Paginate from "../../table/Paginate";
import DatePicker from "react-datepicker";
import {currentDate, getDateDef} from "../../../utils/dateUtils";
import {Jackpot} from "../../jackpot/JackpotValue";
import {getShortBetType} from "../../../utils/tickets/printUtils";
import {fetchRouletteResultReport} from "../../../store/roulette/action";
import RouletteNav from "../RouletteNav";

class RouletteResult extends Component {

    constructor(props) {
        super(props);
        this.state = {
            page: 1,
            date: currentDate(),
            data: null
        }
    }

    componentDidMount() {
        this.onFilter();
    }

    onChange(page) {
        this.onFilter({page: page})
        this.setState({page: page});
    }


    onFilter = (params = {}) => {
        this.props.fetchRouletteResultReport({...this.props.filter, filterDate: getDateDef(this.state.date), ...params})
    }

    render() {
        const {t, data: {items, totals, size}} = this.props;
        return (
            <div className="main-w">

                <div className="main">
                    <div className="w-1200">
                        <div className="wrapper-game-content">
                            <RouletteNav/>
                            <div>
                                <div className="row align-items-center ml-3 mt-2 pb-0">
                                    <div className="form-date-range">
                                        <label>{t("labels:drawing.date")}:</label>
                                    </div>
                                    <div className="pl-2">
                                        <DatePicker
                                            dateFormat="dd-MM-yyyy"
                                            selected={this.state.date}
                                            maxDate={moment().toDate()}
                                            onChange={date => this.setState({date: date})}
                                            className="form-control bg-white"/>
                                    </div>
                                    <div className="wrap-btn-filter">
                                        <button className="btn-game"
                                                onClick={() => this.onFilter()}>{t("labels:common.getResult")}</button>
                                    </div>
                                </div>

                                <LoadingBar scope="sectionBar" style={{backgroundColor: '#448', height: '5px'}}/>

                                <div className="wrapper-game-content">
                                    <div className="table-container pt-0">
                                        <table className="table-custom">
                                            <thead>
                                            <tr>
                                                <th className="text-center">{t("labels:drawing.no")}</th>
                                                <th className="text-center">{t("labels:drawing.date")}</th>
                                                <th className="text-center">{t("labels:drawing.drawCode")}</th>
                                                <th className="text-center">{t("labels:drawing.result")}</th>
                                                <th className="text-center">{t("labels:drawing.underOver")}</th>
                                                <th className="text-center">{t("labels:drawing.oddEvenCode")}</th>
                                                <th className="text-center">{t("labels:drawing.colorCode")}</th>
                                                <th className="text-center">{t("labels:drawing.jackpot")}</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {
                                                _.isEmpty(items)
                                                    ? <tr>
                                                        <td colSpan={9}>{t("labels:common.noData")}</td>
                                                    </tr>
                                                    : items.map((item, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td className="text-center">{index + 1}</td>
                                                                <td className="text-center">{getDateDef(item.createdAt)}</td>
                                                                <td className="text-center">
                                                                    <span
                                                                        className="title-ticket-id-btn">{item.drawLabel}</span>
                                                                </td>
                                                                <td className="text-center">{item.result}</td>
                                                                <td className={"text-center left-bet-type-roulette-" + item.underOverCode}>{t("labels:betPrefix.S_" + getShortBetType(item.underOverCode))}</td>
                                                                <td className={"text-center"}>{t("labels:betPrefix." + item.oddEvenCode)}</td>
                                                                <td className={"text-center left-bet-type-roulette-" + item.colorCode}>{t("labels:drawing.drawPrefix." + item.colorCode)}</td>
                                                                <td className={"text-center"}>
                                                                    <Jackpot item={item} t={t}/>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                            }
                                            </tbody>
                                        </table>
                                    </div>

                                    {
                                        totals > 0
                                            ? <div className="mt-2">
                                                <Paginate
                                                    page={this.state.page}
                                                    size={size}
                                                    total={totals}
                                                    onChange={page => this.onChange(page)}
                                                />
                                            </div>
                                            : null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return state.roulette.resultReport
};

const mapDispatchToProps = dispatch => ({
    fetchRouletteResultReport: payload => dispatch(fetchRouletteResultReport(payload)),
});

export default withTranslation()(connect(
    mapStateToProps,
    mapDispatchToProps
)(RouletteResult));
